import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loading-component',
  template: `
    <div class="d-flex h-100 justify-content-center">
      <div class="text-center align-self-center">
        <div class="spinner-border text-gray" role="status"></div>
        <p class="small text-gray"> {{ message }}</p>
    </div>
  </div>
  `
})
export class LoadingComponent {
  @Input()
  message = 'Loading... Please Wait';
}
